import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12ebf0a5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "option-content type" }
const _hoisted_2 = {
  key: 0,
  class: "footer-pill-buttons"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "shoutout-coaching-label" }, " SEND TO ALL MENTIONED USERS AS A ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "send-reply-label" }, "SEND REPLY TO CONTACT", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Typography = _resolveComponent("Typography")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_ReplyTemplateSelectorModal = _resolveComponent("ReplyTemplateSelectorModal")!
  const _component_MentionWarningModal = _resolveComponent("MentionWarningModal")!
  const _component_MomentTextBox = _resolveComponent("MomentTextBox")!
  const _component_PillButton = _resolveComponent("PillButton")!
  const _component_MomentModalFooter = _resolveComponent("MomentModalFooter")!
  const _component_OverCardModal = _resolveComponent("OverCardModal")!

  return (_openBlock(), _createBlock(_component_OverCardModal, { "close-popup": _ctx.onClosePopup }, {
    "header-center": _withCtx(() => [
      _createVNode(_component_Typography, {
        variant: "subtitle1",
        class: _normalizeClass(['message-context-text', _ctx.composerType])
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.messageType), 1)
        ], undefined, true),
        _: 1
      }, 8, ["class"])
    ]),
    default: _withCtx(() => [
      (_ctx.showTemplateDropdown && _ctx.sendReplyToContact)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "message-option",
            onClick: _cache[0] || (_cache[0] = () => (_ctx.showReplyTemplateModal = true))
          }, [
            _createVNode(_component_Typography, {
              variant: "body2",
              class: _normalizeClass(["option-label", ['message-context-text', _ctx.composerType]])
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Template ")
              ], undefined, true),
              _: 1
            }, 8, ["class"]),
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_Typography, {
                variant: "body2",
                class: _normalizeClass(['message-context-text', _ctx.composerType])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.templateName), 1)
                ], undefined, true),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_FontAwesomeIcon, {
                icon: _ctx.chevronDownIcon,
                class: _normalizeClass(['message-context-text', _ctx.composerType])
              }, null, 8, ["icon", "class"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_ReplyTemplateSelectorModal, {
        "modal-open": _ctx.showReplyTemplateModal,
        "loading-templates": _ctx.loadingTemplates,
        onCloseModal: _cache[1] || (_cache[1] = () => (_ctx.showReplyTemplateModal = false))
      }, null, 8, ["modal-open", "loading-templates"]),
      _createVNode(_component_MentionWarningModal, {
        "modal-open": _ctx.showMentionWarningModal,
        onCloseModal: _cache[2] || (_cache[2] = () => (_ctx.showMentionWarningModal = false))
      }, null, 8, ["modal-open"]),
      _createVNode(_component_MomentTextBox, {
        value: _ctx.mentionText,
        placeholder: _ctx.inputPlaceHolder,
        class: "moment-modal-rich-text",
        onInput: _ctx.catchInput
      }, null, 8, ["value", "placeholder", "onInput"])
    ]),
    footer: _withCtx(() => [
      (!_ctx.showTemplateDropdown && _ctx.$companyVars.has_notices)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_PillButton, {
              label: "SHOUTOUT",
              class: _normalizeClass(['shoutout', _ctx.shoutoutSelected]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleButton(_ctx.messageTypeValues.shoutout.toString())))
            }, null, 8, ["class"]),
            _createVNode(_component_PillButton, {
              label: "COACHING TIP",
              class: _normalizeClass(['coaching', _ctx.coachingSelected]),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleButton(_ctx.messageTypeValues.coaching.toString())))
            }, null, 8, ["class"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showTemplateDropdown && _ctx.hasPermission)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "footer-checkbox",
            onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.sendReplyToggle()), ["stop"]))
          }, [
            (_ctx.sendReplyToContact)
              ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                  key: 0,
                  class: "checkbox",
                  icon: _ctx.faCheckSquare,
                  size: "lg"
                }, null, 8, ["icon"]))
              : (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                  key: 1,
                  class: "checkbox",
                  icon: _ctx.faSquare,
                  size: "lg"
                }, null, 8, ["icon"])),
            _hoisted_4
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_MomentModalFooter, {
        "can-send-message": _ctx.sendButtonDisabled,
        "can-add-image": _ctx.canAddImage,
        onSend: _ctx.onSendMoment
      }, null, 8, ["can-send-message", "can-add-image", "onSend"])
    ]),
    _: 1
  }, 8, ["close-popup"]))
}